import { t } from '@lingui/core/macro';
import { NoddiInfoBanner } from 'noddi-ui-web';

type Props = {
  /** When set, the flow redirects to the existing booking shortly after. */
  existingBookingUrl?: string | null;
};

/** Shared warning shown when a booking already exists for the car and season. */
export const StationaryBookingExistsBanner = ({ existingBookingUrl }: Props) => (
  <NoddiInfoBanner
    variant='warning'
    title={t`Booking already exists`}
    texts={[
      {
        value: existingBookingUrl
          ? t`A booking already exists for this car and season. Redirecting to your existing booking...`
          : t`A booking already exists for this car and season.`
      }
    ]}
  />
);
